


var winOnLoadFlag = false;



// 스무스 스크롤
/*! Scrolling Control  */
var useScrollSmooth = true;
(function($) {
    // if mobile device, add mobile class in body tag
    var isMobile = !deviceCheck();
    if (isMobile) {
        $('body').addClass('touch').removeClass('no-touch');
    } else {
        $('body').removeClass('touch').addClass('no-touch');
    }
    if (isMobile || isBrowserCheck() == 'Firefox') {
        return false;
    }
    if (window.addEventListener) {
        window.addEventListener('DOMMouseScroll', wheel, false);
        if (isBrowserCheck() == 'Chrome') {
            window.addEventListener('wheel', wheel, {
                passive: false
            });
        }
    }
    window.onmousewheel = document.onmousewheel = wheel;

    function wheel(event) {

    	//팝업이 떠 있으면 스크롤 안 되도록
		var dimLayerEl = $(".thinq-section").find(".common-layer-dim");
		if( $(dimLayerEl).length > 0 ){
			return;
		}


        if (useScrollSmooth) {
            //console.log('wheel')
            var delta = 0;
            if (event.wheelDelta) delta = event.wheelDelta / 30; // lower is faster
            else if (event.detail) delta = -event.detail / 3;
            handle(delta);
            if (event.preventDefault) event.preventDefault();
            event.returnValue = false;
        } else {
            return true;
        }
    }
    var goUp = true;
    var end = null;
    var interval = null;

    function handle(delta) {
        if (useScrollSmooth) {
            var animationInterval = 15; //lower is faster
            var scrollSpeed = 10; //lower is faster
            if (end == null) {
                end = $(window).scrollTop();
            }
            end -= 20 * delta;
            goUp = delta > 0;
            if (interval == null) {
                interval = setInterval(function() {
                    if (useScrollSmooth) {
                        var scrollTop = $(window).scrollTop();
                        var step = Math.round((end - scrollTop) / scrollSpeed);
                        //if (scrollTop <= 0 || scrollTop >= $(window).prop("scrollHeight") - $(window).height() || goUp && step > -1 || !goUp && step < 1 ) {
                        if (!useScrollSmooth || scrollTop <= 0 || scrollTop > $(document).height() - $(window).height() || goUp && step > -1 || !goUp && step < 1) {
                            clearInterval(interval);
                            interval = null;
                            end = null;
                            //console.log('clear scroll interval');
                        }
                        $(window).scrollTop(scrollTop + step);
                        //console.log('handle', $(window).scrollTop());
                    } else {
                        if (interval) clearInterval(interval);
                        interval = null;
                        end = null;
                        return false;
                    }
                }, animationInterval);
            }
        } else {
            return true;
        }
    }
})(jQuery);





// TOP버튼 등으로 화면이 자동 스크롤되는 중간에 캐러셀과 관련된 마우스 휠 처리를 막기 위한 변수인 것으로 추정
// false이면 캐러셀 스크롤 잠금, 풀림 기능이 작동하지 않는다.
// var appInroScrollTF = true;



$(function(){

	if( $('.thinq-section').length == 0 ) return;
	var $thinq = $('.thinq-section');
	var $appArea = $thinq.find('.app-area');
	var $mainTitle = $appArea.find('.app-visual .title-area');
	var $mobileDevice = $appArea.find('.mobile-device');
	var $mobileDeviceStatic = $appArea.find('.mobile-device-static');
	var $valueControlArea = $appArea.find('.app-value-carousel');

	//var $valueVoiceArea = $appArea.find('.voice');
	// var $valueCarelArea = $appArea.find('.smart-diagnosis');		// 화면을 따라 다니는 디바이스 엘리먼트
	var $valueCarelArea = $("#end-of-device");		// 화면을 따라 다니는 디바이스 엘리먼트


	var $appDownload = $thinq.find('.app-download');
	var $tabArea = $('.tab-area-desktop');

	if(navigator.userAgent.match(/iPhone|iPad|iPod/i)){
		if(!$appDownload.hasClass('is-mobile')){
			$appDownload.addClass('is-mobile ios');
			$mainTitle.addClass('is-mobile ios');
			$thinq.addClass('is-mobile ios');
		}
	} else if (navigator.userAgent.match(/Android|Tablet/i)){
		if(!$appDownload.hasClass('is-mobile')){
			$appDownload.addClass('is-mobile').removeClass('ios');
			$mainTitle.addClass('is-mobile').removeClass('ios');
			$thinq.addClass('is-mobile').removeClass('ios');
		}
	} else {
		$appDownload.removeClass('is-mobile ios');
		$mainTitle.removeClass('is-mobile ios');
		$mainTitle.find('.button').css('opacity','1');
		$thinq.removeClass('is-mobile ios');
	}

	/*
	 * Sticky Menu
	 */
	function stickyMenu() {
 		var $stickyArea = $thinq.find('.sticky-menu');
 		var $stickyLink = $stickyArea.find('.menu-list');
		var $stickyInner = $stickyArea.find('.sticky-inner');
 		var stickyHeight;
 		var stickyUpperHeight;
 		var activeLineWidth;

 		function stickyResizeSet(){
 			stickyHeight = $stickyArea.height();
 			var naviHeight = $('.navigation').height();
 			var breadcrumbHeight = $('.breadcrumb').height();


 			if(window.innerWidth >= 768) {
 				$('body').removeClass('isMobile');
 				stickyUpperHeight = naviHeight + breadcrumbHeight;
 			} else {
 				$('body').addClass('isMobile');
 				stickyUpperHeight = naviHeight;

 			}
 			// sticky fixed reset
 			if( $(window).scrollTop() >= stickyUpperHeight ){
 				if(!$stickyArea.hasClass('fixed')){
 					$stickyArea.addClass('fixed');
          setTimeout(function(){
						$stickyInner.find('.arrow').addClass('js-fade');
					},3000);
 				}
 			} else {
 				if($stickyArea.hasClass('fixed')){
 					$stickyArea.removeClass('fixed');
 				}
 			}
 		}

    function mobileActiveScroll(){
			$stickyArea.find('ul').each(function (){
		  	var _width = $(this).width(),
		    		_length = $(this).length,
		        _index = $(this).find('.active').index();
		    $stickyLink.scrollLeft((_width/_length) * _index);
			});
		}

 		function stickyScrollSet(){
 			var windowTop = $(window).scrollTop();
      mobileActiveScroll();
 			if(windowTop >= stickyUpperHeight){
 				// sticky fixed
 				if(!$stickyArea.hasClass('fixed')){
 					$stickyArea.addClass('fixed');
          mobileActiveScroll();
          setTimeout(function(){
						$stickyInner.find('.arrow').addClass('js-fade');
					},3000);
 				}
 			} else {
 				if($stickyArea.hasClass('fixed')){
 					$stickyArea.removeClass('fixed');
 				}
 			}
 		}

		// Product Tab Scroll Design
		function mScrollCheck(){
			if( $('body').hasClass('no-touch') ){
				$stickyInner.find('.menu-list').mCustomScrollbar({
					theme:'dark',
					mouseWheelPixels:300,
					axis:'x'
				});
			} else {
				$stickyInner.append('<div class="arrow"></div>');
				// $stickyInner.on('touchend', function(){
				// 	$stickyInner.find('.arrow').addClass('js-fade');
				// });
			}
		}

		mScrollCheck();
 		$(window).on('resize.stickyResizeSet', stickyResizeSet).trigger('resize.stickyResizeSet');
 		$(window).on('scroll.stickyScrollSet', stickyScrollSet).trigger('scroll.stickyScrollSet');

 	}

	function appInteraction(){
		var windowHeight;
		var windowWidth;
		var mainTitleHeight;
		var careHeight;
		var mainTitleOffset;
		var controlOffset;
		var voiceOffset;
		var careOffset;

		var deviceUpperHeight;
		var deviceHeightSmall;

		//var deviceScaleCalc;
		var scaleRatio;
		var scaleValue;
		var scaleResult;
		var deviceResult;
		var valignMiddle;
		var careMiddle;
		var startPoint;								// 디바이스 fixed가 시작되는 세로 위치
		var endPoint;								// 디바이스 fixed가 끝나는 세로 위치

		//screen
		var $screenSlide = $('.screen-slide');					//Feature 02
		var $screenInSlide = $('.screen-in-slide');
		var $screenTabSlide0 = $('.screen-tab-slide0');			//Feature 01
		var $screenTabSlide1 = $('.screen-tab-slide1');			//Feature 03



		//
		var prvScrollTop;
		var screeSlidePrveIdx = 0;
		// var appValueDownFixUse = true;				// 아래로 스크롤하다가 캐러셀이 화면 가운데로 위치했을 때의 스크롤 잠김 여부
		// var appValueUpFixUse = false;				// 위로 스크롤하다가 캐러셀이 화면 가운데로 위치했을 때의 스크롤 잠김 여부
		var appValueCnt = 0;						// 캐러셀의 현재 이미지 번호. 현재 총 3장이며 0~2까지 범위.
		var appBrowserDirect;
		// var wheelSlideTF = true;					// 캐러셀에서 화면 스크롤을 잠글지 여부

		var deviceResizeInterval = false;


		// 리사이즈 이벤트 처리
		// 화면 크기 변경에 따라서 디바이스 이미지를 알맞게 세팅한다.
		function deviceResizeSet(){
			if(deviceResizeInterval) clearTimeout(deviceResizeInterval);
			deviceResizeInterval = setTimeout(function() {
				var scrollTop = $(window).scrollTop();
				var naviHeight = $('.navigation').outerHeight();
				var breadcrumbHeight = $('.breadcrumb').outerHeight();

				windowHeight = window.innerHeight;
				windowWidth = window.innerWidth;
				mainTitleHeight = $mainTitle.outerHeight();
				careHeight = $valueCarelArea.outerHeight();
				mainTitleOffset = $mainTitle.offset().top;
				controlOffset = $valueControlArea.offset().top;
				//voiceOffset = $valueVoiceArea.offset().top;
				careOffset = $valueCarelArea.offset().top;
				deviceUpperHeight = naviHeight + breadcrumbHeight + mainTitleHeight;

				if( window.innerWidth > 1600 ){
					deviceHeightSmall = 753;
					scaleRatio = 0.56;
				} else if( window.innerWidth <= 1600 && window.innerWidth > 1300) {
					deviceHeightSmall = 632;
					scaleRatio = 0.47;
				} else if( window.innerWidth <= 1300 && window.innerWidth > 1085 ) {
					deviceHeightSmall = 524;
					scaleRatio = 0.39;
				} else if( window.innerWidth <= 1085 ) {
					deviceHeightSmall = 430;
					scaleRatio = 0.32;
				}

				if(window.innerWidth >= 768) {
					$('body').removeClass('isMobile');
				} else {
					$('body').addClass('isMobile');
				}

				// scale control
				scaleValue = 1 - (scrollTop / deviceHeightSmall);
				scaleResult = scaleValue.toFixed(2);
				deviceResult = deviceHeightSmall - scrollTop;
				scaleControl();
				heightControl();

				// vertical align middle, fixed
				valignMiddle = (windowHeight - deviceHeightSmall) / 2;
				startPoint = deviceUpperHeight - valignMiddle;
				careMiddle = (careHeight - deviceHeightSmall) / 2;
				endPoint = careOffset + careHeight - deviceHeightSmall - valignMiddle - careMiddle;
				deviceFixed(scrollTop);
				deviceSlide(scrollTop);
			}, 100);
		}


		// 디바이스가 화면을 따라다니는 기능 관련처리
		function deviceScrollSet(){
			var scrollTop = $(window).scrollTop();
			mainTitleOffset = $mainTitle.offset().top;
			controlOffset = $valueControlArea.offset().top;
			//voiceOffset = $valueVoiceArea.offset().top;
			careOffset = $valueCarelArea.offset().top;			// 디바이스 top

			//var scaleValue = 1 - (scrollTop / deviceScaleCalc);
			scaleValue = 1 - (scrollTop / deviceHeightSmall);
			scaleResult = scaleValue.toFixed(2);
			deviceResult = deviceHeightSmall - scrollTop;
			scaleControl();							// 디바이스 크기 컨트롤
			heightControl();						// 디바이스 세로 크기 컨트롤

			endPoint = careOffset + careHeight - deviceHeightSmall - valignMiddle - careMiddle;
			deviceFixed(scrollTop);					// 디바이스 세로위치 컨트롤
			deviceScreenLoad(scrollTop);			// 디바이스 이미지 화면 바꾸기 및 로딩 화면 컨트롤(?)
			deviceSlide(scrollTop);					// screenSlideGoTo() 호출하여 디바이스의 내용을 좌우로 스크롤하면서 바꿈

			txtInteraction(scrollTop);				// 화면이 스크롤되어 텍스트 개체가 화면에 들어오면 애니메이션 등장효과를 실시한다.
			//

		}


		// 디바이스 크기 컨트롤
		function scaleControl(){
			if ( scaleResult <= scaleRatio) scaleResult = scaleRatio;
			$mobileDevice.find('.frame').css('transform', 'scale('+ scaleResult +')');
		}

		// 디바이스 세로 크기 컨트롤
		function heightControl(){
			if ( deviceResult <= deviceHeightSmall) deviceResult = deviceHeightSmall;
			$mobileDevice.css('height', deviceResult);
		}

		//디바이스 세로 위치 컨트롤
		function deviceFixed(scrollTop){
			if( scrollTop <= startPoint ){

				// (1)디바이스가 따라다니는 범위보다 위쪽일 때
				$mobileDevice.removeClass('fixed');



				if(!$('body').hasClass('isMobile')){
					$valueControlArea.css({'margin-top':valignMiddle});
				} else {
					$valueControlArea.css({'margin-top':'0'});
				}



			} else if( scrollTop > startPoint && scrollTop <= endPoint ) {

				// (2)디바이스 따라다니는 범위 안에 있을 때
				$mobileDevice.addClass('fixed');

				var fixedMargin = deviceResult + valignMiddle;
				if(!$('body').hasClass('isMobile')){
					$valueControlArea.css({'margin-top':fixedMargin});
				} else {
					$valueControlArea.css({'margin-top':'0'});
				}

				if(valignMiddle <= 0){
					$mobileDevice.css({'top':'0'});
				} else {
					$mobileDevice.css({'top':valignMiddle});
				}
			} else if( scrollTop > endPoint ) {

				// (3)디바이스가 따라다니는 범위보다 아랫쪽일 때
				var scrollValue = scrollTop - endPoint;
				var valignEnd = valignMiddle - scrollValue;

				$mobileDevice.css({'top':valignEnd});
			}
		}

		// 디바이스 이미지 화면 바꾸기 및 로딩 화면 컨트롤(?)
		function deviceScreenLoad(scrollTop){
			//mainTitleOffset = mainTitleOffset + 100;

			if( scrollTop >= mainTitleOffset ){
				if(!$mobileDevice.find('.frame').hasClass('active')){
					$mobileDevice.find('.frame').addClass('active');
				}
				if(!$mobileDeviceStatic.hasClass('active')){
					$mobileDeviceStatic.addClass('active');
				}
			} else {
				if($mobileDevice.find('.frame').hasClass('active')){
					$mobileDevice.find('.frame').removeClass('active');
				}
				if($mobileDeviceStatic.hasClass('active')){
					$mobileDeviceStatic.removeClass('active');
				}
			}
		}


		// 스크롤 처리의 일부
		// 디바이스의 내용을 좌우로 스크롤하면서 바꿈
		// 현재 어떤 개체에 디바이스가 위치해 있는지 저장(screeSlidePrveIdx 세팅)
		function deviceSlide(scrollTop){

			if(windowWidth < 768) return false;

			//scrollTop
			var _idx,
			topArr=[],
			_wh = $(window).height(),
			$appAreaCon = $appArea.find('.app-con'),
			_len = $appAreaCon.length;
			for(i=0;i<_len;i++){
				topArr[i] = $appAreaCon.eq(i).offset().top-(_wh/1.8);
			}

/*
			if(scrollTop < topArr[0]){
				_idx = 0
			}else if(scrollTop >= topArr[0] && scrollTop < topArr[1]){
				_idx = 1
			}else if(scrollTop >= topArr[1] && scrollTop < topArr[2]){
				_idx = 2
			}else if(scrollTop >= topArr[2] && scrollTop < topArr[3]){
				_idx = 3
			}else if(scrollTop >= topArr[3] && scrollTop < topArr[4]){
				_idx = 4
			}else if(scrollTop >= topArr[4]){
				_idx = 5
			}
*/

			if(scrollTop < topArr[0]){
				_idx = 0;
			}else if(scrollTop >= topArr[0] && scrollTop < topArr[1]){
				_idx = 1;
			}else if(scrollTop >= topArr[1] && scrollTop < topArr[2]){
				_idx = 2;
			}else if(scrollTop >= topArr[2] && scrollTop < topArr[3]){
				_idx = 3;
			}else if(scrollTop >= topArr[3]){
				_idx = 4;
			}

			if(_idx != screeSlidePrveIdx){
				screenSlideGoTo($screenSlide,_idx);		// 디바이스의 내용을 좌우로 스크롤하면서 바꿈
				screeSlidePrveIdx = _idx;
			}

		}

		//화면이 스크롤되어 텍스트 개체가 화면에 들어오면 애니메이션 등장효과를 실시한다.
		function txtInteraction(scrollTop){
			var $target = $('.app-animate-target');

			$target.each(function() {
				var $self = $(this);
				var current = $self.offset().top;
				var scrollBottom = scrollTop + windowHeight - $self.outerHeight();

				if( !$self.hasClass('animated') ) {
					if( current > scrollTop && current <= scrollBottom  ) {
							$self.addClass('animated');
					}
				}
			});
		}


		// (세로로 나열된) 탭 클릭 이벤트
		function tabArea(){
			$tabArea.each(function(){
				$(this).find('.tab-list a').on('click',function(e){
					e.preventDefault;
					var idx = $(this).parent().index();
					var tabItem = $(this).parents('.tab-area-desktop').find('.tab-item');
					$(this).parent().addClass('on').siblings().removeClass('on');
					tabItem.eq(idx).addClass('on').siblings().removeClass('on');

					if(!$(this).closest('.app-feature').hasClass('pcc')){
						screenSlideGoTo($screenTabSlide0,idx);		// 디바이스 내용을 좌우 스크롤하여 전환
					}else{
						screenSlideGoTo($screenTabSlide1,idx);		// 디바이스 내용을 좌우 스크롤하여 전환
					}

/*
					if( $(this).closest('.app-feature').hasClass('pcc') ){
						screenSlideGoTo($screenTabSlide1,idx);		// 디바이스 내용을 좌우 스크롤하여 전환

					}else if( $(this).closest('.app-feature').hasClass('pcc') ){
						screenSlideGoTo($screenTabSlide0,idx);		// 디바이스 내용을 좌우 스크롤하여 전환
					}
*/

				})
			});
		}


		//슬릭 시작
		function ScrollCarousel(){
			var $appCarousel = $thinq.find("#app-value-carousel");
			$appCarousel.slick({
				speed : 700,
				dots: true,
				infinite: false,
				autoplaySpeed: 5000
				/*speed : 700,
				dots: false,
				infinite: false,
				arrows: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							arrows: true,
							dots:true
						}
					}
				]*/
			}).on('afterChange',function(event, slick, currentSlide){
				screenSlideGoTo($screenInSlide,currentSlide);
				$valueControlArea.find('.item .title-area').removeClass('animated');
				$valueControlArea.find('.item:eq('+currentSlide+') .title-area').addClass('animated');
			});
		}

		//모바일용 슬릭 시작
		function featureMobileCarousel(){
			$appArea.find('.feature-carousel').each(function(){
				$(this).slick({
					dots:true,
					infinite: false,
					arrows: true
				});
			})
		}

		// 디바이스의 내용을 좌우로 스크롤하면서 바꿈
		function screenSlideGoTo(ta,idx){
			var _l = -100*idx;
			ta.stop().animate({left:_l+'%'},400);
		}



		//캐러셀 좌우 버튼 위치 제한, 팝업 위치
		function appCarouselArrowPosition(){

			var prevEl = $("#app-value-carousel button.slick-prev.slick-arrow");
			var nextEl = $("#app-value-carousel button.slick-next.slick-arrow");
			var itemEl = $("#app-value-carousel .slick-list .slick-track .slick-slide.slick-current .image-area").eq(0);

			if( $(itemEl).length > 0 ){
				if( $(itemEl).offset().left > 0 ){
					setTimeout(function(){
						$(prevEl).css("left",Number($(itemEl).offset().left) + 193);
						$(nextEl).css("right",Number(($(window).innerWidth() - $(itemEl).width()) / 2) + 193);

					},100);
				}else{
					setTimeout(function(){
						$(prevEl).css("left","6.5%");
						$(nextEl).css("right","6.5%");
					},100);
				}
			}


			//Feature 01 - 양쪽 div 세로 중앙 정렬
			var f01ConEl = $(".app-feature.remote-control");
			var destEl1 = $(f01ConEl).find(".tab-list");
			var destEl2 = $(f01ConEl).find(".title-area").eq(0);
			var mt1 = $(f01ConEl).height() / 2 - $(destEl1).height()/2 - 60;
			$(destEl1).css("margin-top", mt1);
			var pt1 = $(f01ConEl).height() / 2 - $(destEl2).height()/2 + 0;
			// var pt1 = Number(mt1) + 32;
			$(destEl2).css("padding-top", pt1);


			// Feature 03 - 양쪽 div 세로 중앙 정렬
			var f03ConEl = $(".app-feature.pcc");
			var destEl1 = $(f03ConEl).find(".tab-list");
			var destEl2 = $(f03ConEl).find(".title-area").eq(0);
			var mt1 = $(f03ConEl).height() / 2 - $(destEl1).height()/2 - 155;
			$(destEl1).css("margin-top", mt1);
			var pt1 = $(f03ConEl).height() / 2 - $(destEl2).height()/2 - 17;
			$(destEl2).css("padding-top", pt1);


		}
		appCarouselArrowPosition();



		function addBulletStyle(){



			// $("#appdownload ul.app-down-info li img").css("left","50px");

/*
			var str = "";
			str += "<style data-app-download-grey-bullet>";
			str += ".app-download-grey-bullet{";
			str += "display: block;";
			str += "position: absolute;";
			str += "left: 6px;";
			str += "top: 12px;";
			str += "background-color:#333;";
			str += "border-radius: 50%;";
			str += "width: 5px;";
			str += "height: 5px;";
			str += "}";
			str += "</style>";
			$("head style[data-app-download-grey-bullet]").remove();
			$("head").append(str);
*/

		}
		addBulletStyle();



		//
		ScrollCarousel();				// 슬릭 시작
		featureMobileCarousel();		// 모바일용 슬릭 시작
		tabArea();						// 탭 클릭 이벤트
		startAppCarousel()				// 앱 캐러셀 시작
		// appValueUseSet();				// 현재 스크롤 위치가 캐러셀의 위인지 아래인지에 따라서 관련 변수를 알맞게 초기화시칸다.
		$(window).on('resize.deviceResizeSet', deviceResizeSet).trigger('resize.deviceResizeSet');			//리사이즈 이벤트 등록 및 최초 실행
		$(window).on('scroll.deviceScrollSet', deviceScrollSet).trigger('scroll.deviceScrollSet');			//스크롤 이벤트 등록 및 최초 실행


		$(window).on('resize.appCarouselArrowPosition', appCarouselArrowPosition).trigger('resize.appCarouselArrowPosition');





		/////////////// APP 소개 페이지

		//// APP VALUE 캐러셀
		function startAppCarousel(){
			var $appCarousel = $thinq.find("#app-value-carousel");
			$appCarousel.slick('slickPlay');
		}

		function stopAppCarousel(){
			var $appCarousel = $thinq.find("#app-value-carousel");
			$appCarousel.slick('slickPause');
		}


		setTimeout(function(){
			var appCarouselEl = $("#app-value-carousel ul.slick-dots");
			// var str = "<button type=\"button\" id=\"appCarouselPlayButton\" class=\"app-carousel-play\">play</button>";
			var str = "<button type=\"button\" id=\"appCarouselPlayButton\" class=\"btn-pause\">play</button>";
			$(appCarouselEl).append(str);
			var playBtnEl = $(appCarouselEl).find("#appCarouselPlayButton");
			playBtnEl.on("click",function(){
				if( !$(this).hasClass("play") ){
					stopAppCarousel();
					$(this).addClass("play");
				}else{
					startAppCarousel();
					$(this).removeClass("play");
				}
			});

		}, 200);



		//// Top Reason 동영상
		var trThumbEl = $(".top-reason-video-area .top-reason-video-thumb");
		var trPlayEl = $(".top-reason-video-area .top-reason-video-thumb .top-reason-play");
		var trVideoLayerEl = $(".top-reason-video-area .top-reason-video-layer");
		var trVideoEl = $("#top-reason-video-id");
		var trCloseBtnEl = $(".top-reason-video-area .top-reason-video-layer .btn-close");


		//Top Reason 동영상 플레이
		function topReasonVideoStart(){
			$(trPlayEl).addClass("tr-icon-pause");
			$(trPlayEl).removeClass("tr-icon-play");
			$(trThumbEl).hide();
			$(trVideoLayerEl).show();
			trVideoEl[0].currentTime = 0;
			trVideoEl[0].play();
		}

		//Top Reason 동영상 정지
		function topReasonVideoStop(){
			$(trPlayEl).addClass("tr-icon-play");
			$(trPlayEl).removeClass("tr-icon-pause");
			$(trThumbEl).show();
			$(trVideoLayerEl).hide();
			// trVideoEl[0].currentTime = 0;
			trVideoEl[0].pause();
		}

		$(trPlayEl).on("click", function(){
			if( $(this).hasClass("tr-icon-play") ){
				// 동영상 정지 상태인 경우
				topReasonVideoStart();
			}else{
				// 동영상 플레이 상태인 경우
				topReasonVideoStop();
			}
		});
		$(trPlayEl).on("mouseover", function(){
			if( $(window).innerWidth() >= 768 ) $(this).css("background-position","-80px 0px");
		});
		$(trPlayEl).on("mouseout", function(){ if( $(window).innerWidth() >= 768 ) $(this).css("background-position","0px 0px"); });
		$(trCloseBtnEl).on("click", function(){ topReasonVideoStop(); });


		// 하단 APP DOWNLOAD
		function showPopup(popupNo){

			var str = "<div class=\"common-layer-dim\"></div>";
			$(".thinq-section").append(str);

			var dimLayerEl = $(".thinq-section").find(".common-layer-dim");
			$("body").css("overflow","hidden");
			$(dimLayerEl).css("opacity","1");

			if( popupNo == 1 ){
				var popupEl = $("#appdownload-popup");

				$(popupEl).show();
				appCarouselArrowPosition();
				var mobileCarEl = $(popupEl).find(".app-download-mobile-carousel-body");
				if( !$(mobileCarEl).hasClass("slick-initialized") ){
					$(mobileCarEl).slick({
						dots:true,
						infinite: false,
						arrows: true
					});
				}

			}else if( popupNo == 2 ){

			}

		}

		function closePopup(){
			$("body").css("overflow","auto");
			var dimLayerEl = $(".thinq-section").find(".common-layer-dim");
			$(dimLayerEl).remove();
			var popupLayerEl = $(".app-download-popup");
			$(popupLayerEl).hide();
		}

		var adDownBtnEl = $(".app-download-learnmore-btn");
		$(adDownBtnEl).on("click", function(){ showPopup(1); });
		var adCloseBtnEl = $(".app-download-close-button");
		$(adCloseBtnEl).on("click", function(){ closePopup(); });


		// TOP버튼을 클릭하여 화면 최상단으로 이동했을 때
		// 캐러셀 컨트롤 및 관련 변수를 알맞게 세팅함으로서
		// 스크롤 잠금 기능과 충돌하지 않게 한다.
		$('.floating-menu.top button').on('click',function(){
			setTimeout(function(){
				useScrollSmooth = true;
				appValueCnt = 0;
				$valueControlArea.slick('slickGoTo',appValueCnt);
				screenSlideGoTo($screenInSlide,appValueCnt);
			},800);
		});

		//HOME키 처리
		$(document).keyup(function(e) {
			if (e.keyCode == 36) {
				useScrollSmooth = false;
				$('.floating-menu.top button').trigger('click');
			}
		});


		function downSet(){
			var appdown = $('#appdownload');
			var _h = appdown.innerHeight();
			var _offsetT = appdown.offset().top - 65;

			useScrollSmooth = true;
			$valueControlArea.slick('slickGoTo',appValueCnt);
			screenSlideGoTo($screenInSlide,appValueCnt);
			if(window.innerWidth >= 768) {
				$('html, body').stop().animate({scrollTop: _offsetT}, 0, function(){
					$("body").css("opacity","1");
				});
			}else{
				$('html, body').stop().animate({scrollTop: _offsetT}, 0);
			}
		}



		// 애니메이션이 필요한 개체가 화면에 들어오면 애니메이션 실행
		function objInteraction(){

			var $obj = $('.app-animate-target-normal');

			$obj.each(function() {

				if( !$(this).hasClass('animated') ) {
					var t = $(this).offset().top;
					var b = $(this).offset().top + $(this).outerHeight();
					if(isInScreen(t, b)) {
						var delayTimer = parseInt($(this).attr('data-delay'));
						if ( $(this).parent().find('.tab-list') ) {
							$(this).delay(delayTimer).queue(function(){
							$(this).addClass('animated');
							var thisObj = $(this);
							setTimeout(function(){
								// thisObj.children().eq(0).addClass("on");
								var childrenOnCnt = 0;
								thisObj.children().each(function(index,item){
									if( $(this).hasClass("on") ){ childrenOnCnt++; return false; }
								});
								if( childrenOnCnt == 0 ) thisObj.children().eq(0).addClass("on");							
							},delayTimer+200);
							});
						} else {
							$(this).delay(delayTimer).queue(function(){$(this).addClass('animated')});
						}
					}
				}
			});
		}

		$(window).on('scroll.objInteraction', objInteraction).trigger('scroll.objInteraction');


		if(window.location.hash == '#appdownload') {
			var arrUrl = window.location.href.split("?");
			var arrUrl2 = arrUrl[0].split("#");
			location.href = arrUrl2[0] + "?gd=appdownload";
		}


		var winOnLoad = function () {
			//해시태그가 있을 경우 해당 해시태그로 바로 이동 처리
			var visibleFlag = false;
			var arrGetParam = window.location.href.split("?");
			if( arrGetParam.length > 1 ){
				var arrGetParam2 = arrGetParam[1].split("&");
				for( var i=0 ; i < arrGetParam2.length ; i++ ){
					if( arrGetParam2[i].indexOf("gd=") != -1 ){
						var gd = arrGetParam2[i].split("=")[1];
						if( gd == "appdownload" ){
							downSet();
							visibleFlag = true;
						}
					}
				}
			}
			if( !visibleFlag ) $("body").css("opacity","1");
		}

		var loopCnt = 0;
		var tiId = setInterval(function(){
			if( winOnLoadFlag ){
				winOnLoad();
				clearInterval(tiId);
			}
			//강제 루프탈출
			if( loopCnt++ > 50 ) clearInterval(tiId);
		}, 100);




	}
	appInteraction();
	stickyMenu();
});




window.onload = function () {
  winOnLoadFlag = true;
}
